export default __webpack_public_path__ + "static/media/ps-without-battery.63b97031.jpg";